"use client"; // This directive MUST be at the very top of the file

import dynamic from "next/dynamic"; // <-- Dodano import dynamic
import { useTranslations } from "next-intl"; // Correct import for client-side translations
import React, { useState } from "react";

import Header from "@/components/design/header";

// NIE IMPORTUJEMY TERAZ INTERACTIVEMAP BEZPOŚREDNIO TUTAJ
// import InteractiveMap from "./interactive-map";

import JourneyOptions from "./journey-options";
import { type GeoJSONLineStringFeature } from "./map";
import {
  MAPBOX_CUSTOM_STYLE_URL,
  MAP_INITIAL_CENTER,
  MAP_INITIAL_ZOOM,
  JOURNEY_ROUTES,
} from "./map-data";
import MobileJourneyOptions from "./mobile-journey-options";

/**
 * Builds a translation namespace string based on the route and component name.
 *
 * @param route The current route (e.g., "/", "/about-us").
 * @param component The component name (e.g., "journeySection").
 * @returns The full translation namespace string.
 */
export function buildNamespace(route: string, component: string): string {
  if (route === "/") return `pages.root.${component}`;
  const key = route.replace(/^\//, "").replace(/\//g, ".");
  return `pages.${key}.${component}`;
}

/* ---------------------------------------------------------------- types -- */
interface JourneySectionProps {
  route: string;
}

/* -------------------------------------------------------------- component -- */

// Nowy, dynamicznie ładowany komponent Mapy
const DynamicInteractiveMap = dynamic(
  () => import("./interactive-map"), // Ścieżka do Twojego komponentu InteractiveMap
  {
    ssr: false, // KLUCZOWE: Ten komponent będzie renderowany TYLKO po stronie klienta.
    // Biblioteka mapbox-gl.js nie zostanie załadowana na serwerze.
    loading: () => <p>Ładowanie mapy...</p>, // Opcjonalny fallback, gdy mapa się ładuje
  },
);

export default function JourneySection({ route }: JourneySectionProps) {
  const t = useTranslations(buildNamespace(route, "journeySection"));

  const [selectedRoute, setSelectedRoute] = useState<GeoJSONLineStringFeature>(
    JOURNEY_ROUTES[0]!.geoJSON,
  );

  const handleRouteSelect = (geoJSON: GeoJSONLineStringFeature) => {
    setSelectedRoute(geoJSON);
  };

  return (
    <section className="mt-16 w-full lg:mt-0">
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-20">
        <Header>{t("title", { defaultValue: "Dojazd" })}</Header>
        <div className="relative h-[210px] w-full overflow-hidden rounded-[20px] p-5 lg:h-[410px] lg:p-0">
          <div className="h-[170px] overflow-hidden rounded-[20px] lg:h-[500px]">
            {/* Używamy dynamicznie ładowanej mapy */}
            <DynamicInteractiveMap
              center={MAP_INITIAL_CENTER}
              zoom={MAP_INITIAL_ZOOM}
              routeGeoJSON={selectedRoute}
              customStyleUrl={MAPBOX_CUSTOM_STYLE_URL}
            />
          </div>
          <JourneyOptions
            onRouteSelect={handleRouteSelect}
            selectedRouteGeoJSON={selectedRoute}
          />
        </div>
        <MobileJourneyOptions
          onRouteSelect={handleRouteSelect}
          selectedRouteGeoJSON={selectedRoute}
        />
      </div>
    </section>
  );
}
